<div class="d-block">
  <ul class="nav nav-secondary" role="leaderboardnav" aria-label="leaderboard nav">
    <div class="mixed-loyalty-nav" [ngClass]="{ 'container justify-content-start': isRulesEnabled }">
      <a
        class="nav-item leaderboard-nav-item"
        [ngClass]="{ 'nav-item-pickaplayer': isRulesEnabled }"
        [routerLink]="['/games-v2/' + routeLink]"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{ 'game.nav.' + routeLink + '.v2.screenreader' | translate }}"
      >
        <label>{{ routeLink + '.v2.nav.featured' | translate: { fgbdefault: 'Play' } }}</label>
      </a>
      <a
        class="nav-item leaderboard-nav-item"
        [ngClass]="{ 'nav-item-pickaplayer': isRulesEnabled }"
        [routerLink]="['/games-v2/' + routeLink + '/leaderboard-v2']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{ 'game.nav.' + routeLink + '.v2.leaderboard.screenreader' | translate }}"
      >
        <label>{{ 'games.nav.' + routeLink + '.v2.leaderboard' | translate: { fgbdefault: 'Leaderboard' } }}</label>
      </a>
      <a
        *ngIf="isRulesEnabled"
        class="nav-item leaderboard-nav-item"
        [ngClass]="{ 'nav-item-pickaplayer': isRulesEnabled }"
        [routerLink]="['/games-v2/' + routeLink + '/how-to-play']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{ 'game.nav.' + routeLink + '.v2.rules.screenreader' | translate }}"
      >
        <label>{{ 'games.nav.' + routeLink + '.v2.how.to.play' | translate: { fgbdefault: 'How to Play' } }}</label>
      </a>
    </div>
  </ul>
</div>
